import React, { useMemo } from 'react';
import { NewsCardStyles as S } from './NewsCard.styles';
import { getSrcs } from '@helpers/image';
import Pill from '../../Pill/Pill';
import { LinkButton } from '@stories/Components/Buttons/GeneralButton/Button';
import { SystemIcon, getSvgFromSystem } from '@helpers/systemIcons';
import { withMotion } from '@hoc/withMotion';
import { useInView } from '@hooks/useInView';
import { BurnOverlay } from '@stories/Widgets/ContentAccordion/ContentAccordion.styles';
import { formatDate } from '@helpers/date';
const NewsCard = ({ image, theme, tag, onTagClick, date, title, summary, cta, translations, }) => {
    const srcs = getSrcs(image, 382, 330, 8, 140 / 191);
    const formattedDate = useMemo(() => formatDate(date, 'dd MMM yy'), [date]);
    const [elementRef, inView] = useInView({ threshold: 0.15 });
    return (React.createElement(S.Container, { ref: elementRef, inView: inView, variant: theme },
        image.src &&
            React.createElement(S.ImageWrapper, null,
                React.createElement("img", { src: srcs[0], srcSet: srcs.join(',') }),
                React.createElement(BurnOverlay, null)),
        React.createElement(S.ContentWrapper, null,
            React.createElement(S.TopContentRow, null,
                React.createElement(S.CategoryPill, null,
                    React.createElement(Pill, { text: tag.text, onTagClick: onTagClick })),
                React.createElement(S.Date, null, formattedDate)),
            React.createElement(S.Title, null, title),
            React.createElement(S.Content, null, summary),
            React.createElement(S.ButtonContainer, null,
                React.createElement(LinkButton, { addon: getSvgFromSystem(SystemIcon.ArrowRight), addonPosition: "left", branding: "black", styleType: "outline", title: translations && translations['hyve.listing.news-card.read-more'] ? translations['hyve.listing.news-card.read-more'] : 'Read more', target: cta.target, href: cta.url })))));
};
export default withMotion(NewsCard);
